import { AxiosError, AxiosRequestConfig } from 'axios'
import qs from 'qs'

import { useMutator as useOrvalMutator } from '@dhl/orval'

export type ErrorType<Error> = AxiosError<Error>

const base: AxiosRequestConfig = {
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
}

export const useMutator = <T>(): ((config: AxiosRequestConfig) => Promise<T>) => useOrvalMutator<T>(base)
